import { useEffect, useState } from "react";

export function useMedia(media = 1024) {
  const [isSmallerScreen, setIsSmallerScreen] = useState(false);
  const [screenWidth, setScreenWidth] = useState(1440);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    // Mark that we're now on the client side
    setIsClient(true);
    
    // Only access window properties after client-side hydration
    if (typeof window !== "undefined") {
      setScreenWidth(window.screen.width);
      setIsSmallerScreen(window.screen.width <= media);
    }
  }, [media]);

  // Return default values during SSR to prevent hydration mismatch
  if (!isClient) {
    return { isSmallerScreen: false, screenWidth: 1440 };
  }

  return { isSmallerScreen, screenWidth };
}
